import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withLastLocation } from 'react-router-last-location';

import * as actions from 'store/services/resources/actions';
import * as selectors from 'store/services/resources/selectors';
import { getSidebarIsOpen } from 'store/services/settings/selectors';
import {
  getProject,
  getProjectIsLoading,
} from 'store/services/project/selectors';

import FileSystem from 'components/FileSystem';

export const Resources = ({
  // List props
  listItems,
  isLoadingList,
  isUploading,
  uploadingFilesList,
  hasUploadingFilesError,
  listSearchTerm,
  sidebarIsOpen,
  getFiles,
  addNewFile,
  addFile,
  updateFile,
  updatedSearchTerm,
  openFile,
  uploadFiles,
  resetUploadFiles,
  deleteFiles,
  exportFiles,
  deleteFile,
  exportFile,
  openFiles,
  // Current project
  project,
  projectIsLoading,
  // React router
  location,
  // From withLastLocation
  lastLocation,
  // Editor props
  isLoadingEditor,
  isSaving,
  theme,
  editorSearchTerm,
  selectedFile,
  selectedFiles,
  closeEditorFile,
  setTheme,
  updateEditorSearchTerm,
  updateBlob,
  updateFiles,
}) => (
  <FileSystem
    project={project}
    projectIsLoading={projectIsLoading}
    location={location}
    lastLocation={lastLocation}
    hasNameExceptions
    modelName="resources"
    theme={theme}
    listItems={listItems}
    isLoadingEditor={isLoadingEditor}
    isLoadingList={isLoadingList}
    listSearchTerm={listSearchTerm}
    editorSearchTerm={editorSearchTerm}
    sidebarIsOpen={sidebarIsOpen}
    selectedFile={selectedFile}
    selectedFiles={selectedFiles}
    isSaving={isSaving}
    isUploading={isUploading}
    uploadingFilesList={uploadingFilesList}
    hasUploadingFilesError={hasUploadingFilesError}
    openFile={openFile}
    closeEditorFile={closeEditorFile}
    setTheme={setTheme}
    updateBlob={updateBlob}
    updateEditorSearchTerm={updateEditorSearchTerm}
    getFiles={getFiles}
    addNewFile={addNewFile}
    addFile={addFile}
    updateFile={updateFile}
    updateFiles={updateFiles}
    updatedSearchTerm={updatedSearchTerm}
    uploadFiles={uploadFiles}
    resetUploadFiles={resetUploadFiles}
    deleteFiles={deleteFiles}
    exportFiles={exportFiles}
    deleteFile={deleteFile}
    exportFile={exportFile}
    openFiles={openFiles}
  />
);

Resources.propTypes = {
  ...FileSystem.propTypes,
};

const mapStateToProps = state => ({
  listItems: selectors.getFilteredFiles(state),
  listSearchTerm: selectors.getSearchTerm(state),
  editorSearchTerm: selectors.getEditorSearchTerm(state),
  sidebarIsOpen: getSidebarIsOpen(state),
  theme: selectors.getTheme(state),
  selectedFile: selectors.getEditorCurrentFile(state),
  selectedFiles: selectors.getEditorFiles(state),
  isSaving: selectors.getIsSaving(state),
  isLoadingEditor: selectors.getIsEditorLoading(state),
  isLoadingList: selectors.getIsLoading(state),
  isUploading: selectors.getIsUploading(state),
  uploadingFilesList: selectors.getUploadingFiles(state),
  hasUploadingFilesError: selectors.getHasUploadingFilesError(state),
  // Current project related
  project: getProject(state),
  projectIsLoading: getProjectIsLoading(state),
});

const mapDispatchToProps = dispatch => ({
  openFile: bindActionCreators(actions.openFile, dispatch),
  closeEditorFile: bindActionCreators(actions.closeEditorFile, dispatch),
  setTheme: bindActionCreators(actions.setTheme, dispatch),
  updateBlob: bindActionCreators(actions.updateBlob, dispatch),
  updateEditorSearchTerm: bindActionCreators(
    actions.updateEditorSearchTerm,
    dispatch,
  ),
  getFiles: bindActionCreators(actions.getFiles, dispatch),
  updateFiles: bindActionCreators(actions.updateFiles, dispatch),
  addNewFile: bindActionCreators(actions.addNewFile, dispatch),
  addFile: bindActionCreators(actions.addFile, dispatch),
  updateFile: bindActionCreators(actions.updateFile, dispatch),
  updatedSearchTerm: bindActionCreators(actions.updatedSearchTerm, dispatch),
  uploadFiles: bindActionCreators(actions.uploadFiles, dispatch),
  resetUploadFiles: bindActionCreators(actions.resetUploadFiles, dispatch),
  deleteFiles: bindActionCreators(actions.deleteFiles, dispatch),
  exportFiles: bindActionCreators(actions.exportFiles, dispatch),
  deleteFile: bindActionCreators(actions.deleteFile, dispatch),
  exportFile: bindActionCreators(actions.exportFile, dispatch),
  openFiles: bindActionCreators(actions.openFiles, dispatch),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withLastLocation,
)(Resources);
